module.exports = __webpack_public_path__ + "static/media/odnoklassniki.31259f7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/odnoklassniki.svg
// module id = 205
// module chunks = 0